/* eslint-disable */
// import https from "https";
import fetch from "isomorphic-fetch";
import uuid from "react-native-uuid";

import endPoints from "./endPoints";
import { keycloak, blackBoltUrl, blackBoltVersion } from "../constants";
import Analytics from "../analytics";
import Event from "../analytics/eventFactory";
import { readCookie, createCookie, getClientUniqueId } from "../utils";
import { getStores } from "../stores";

require("es6-promise").polyfill();

let fetchTokenPromise = null;

// let agent = null;
// if (global !== undefined && global.isServer) {
//   agent = new https.Agent({
//     keepAlive: true,
//     keepAliveMsecs: 1500,
//     maxSockets: 70,
//   });
// }

const staticHeaders = {
  correlationid: uuid.v4(),
  module: "odin",
  accept: "application/json",
  "Content-Type": "application/json",
  bbversion: blackBoltVersion,
  clientSessionId: getClientUniqueId() || "",
};

function handleNewErrors(response, requestBody) {
  try {
    if (!response.ok && response.status !== 401) {
      const timestamp = new Date().toUTCString();
      const responseTime = `res1 ${timestamp}`;
      const errorObj = {
        url: response.url,
        clientSessionId: requestBody.headers.clientSessionId || null,
        correlationId: requestBody.headers.correlationid || null,
        statusCode: response.status,
        requestTime: response.requestTime || "",
        responseTime: responseTime || "",
      };
      Analytics.trackEvent({
        category: Event.category.API_FAIL,
        action: Event.action.getApiFailUrl(requestBody.method, response.url),
        label: Event.label.getApiFailObj(errorObj),
      });
    }
    return Promise.all([response.ok, response.json(), response.status]);
  } catch (err) {
    return err;
  }
}

const getTokens = () => {
  const body = JSON.stringify({
    grant_type: "refresh_token",
    refresh_token: readCookie("refreshToken"),
  });
  return post("login", {}, body)
    .then(res => {
      const {
        access_token: accessToken,
        refresh_token: refreshToken,
      } = res.data;
      createCookie("accessToken", accessToken);
      createCookie("refreshToken", refreshToken);
      return accessToken;
    })
    .catch(err => {
      Analytics.trackEvent({
        action: Event.action.REFRESH_TOKEN_FAIL,
        category: Event.category.LOGIN,
      });
      const stores = getStores();
      stores.LoginStore.logoutAction(true);
      throw err;
    });
};

function retry(method, type, customHeaders, body) {
  if (!fetchTokenPromise) {
    fetchTokenPromise = getTokens();
  }
  return fetchTokenPromise.then(accessToken => {
    fetchTokenPromise = null;
    customHeaders.authorization = `Bearer ${accessToken}`;
    return method(type, customHeaders, body);
  });
}

const get = (type, customHeaders, param) => {
  let url = `${endPoints[type]}`;
  const headers = {
    ...customHeaders,
    ...staticHeaders,
  };
  const requestBody = {
    method: "GET",
    headers,
  };
  if (param) {
    url = `${url}${"/"}${param}`;
  }
  return fetch(url, requestBody)
    .then(response => handleNewErrors(response, requestBody))
    .then(response => {
      const [err, res, status] = Array.from(response);
      if (!err) {
        if (status === 401 && blackBoltUrl.indexOf(type) === -1) {
          return retry(get, type, customHeaders);
        }
        throw {
          ...res,
          status,
        };
      } else {
        return res;
      }
    });
};

const post = (type, customHeaders, body, param) => {
  let url = `${endPoints[type]}`;
  const headers = {
    ...customHeaders,
    ...staticHeaders,
  };
  const requestBody = {
    method: "POST",
    headers,
    body,
  };
  if (param) {
    url = `${url}${"/"}${param}`;
  }
  return fetch(url, requestBody)
    .then(response => handleNewErrors(response, requestBody))
    .then(response => {
      const [err, res, status] = Array.from(response);
      if (status === 401 && blackBoltUrl.indexOf(type) === -1) {
        return retry(post, type, customHeaders, requestBody.body);
      }
      if (!err) {
        throw {
          ...res,
          status,
        };
      } else {
        return res;
      }
    });
};

const put = (type, customHeaders, body) => {
  const url = `${endPoints[type]}`;
  const headers = {
    ...customHeaders,
    ...staticHeaders,
  };
  const requestBody = {
    method: "PUT",
    headers,
    body,
  };
  return fetch(url, requestBody)
    .then(response => handleNewErrors(response, requestBody))
    .then(response => {
      const [err, res, status] = Array.from(response);
      if (!err) {
        if (status === 401 && blackBoltUrl.indexOf(type) === -1) {
          return retry(put, type, customHeaders, requestBody.body);
        }
        throw {
          ...res,
          status,
        };
      } else {
        return res;
      }
    });
};

const deleteApi = (type, customHeaders, body, params) => {
  const url = `${endPoints[type]}${params}`;
  const headers = {
    ...customHeaders,
    ...staticHeaders,
  };
  const requestBody = {
    method: "DELETE",
    headers,
    body,
  };
  return fetch(url, requestBody)
    .then(response => handleNewErrors(response, requestBody))
    .then(response => {
      const [err, res, status] = Array.from(response);
      if (status === 401 && blackBoltUrl.indexOf(type) === -1) {
        return retry(post, type, customHeaders, requestBody.body);
      }
      if (!err) {
        throw {
          ...res,
          status,
        };
      } else {
        return res;
      }
    });
};
export { get, post, put, endPoints, getTokens, deleteApi };



// WEBPACK FOOTER //
// ./src/api/index.js